export enum ChartType {
  XBarR = 'XBarR',
  XBarS = 'XBarS',
  XMR = 'XMR',
}
